import baseService from "./Base-service";

class AccessGroupService {

    get controllerName() { return '/Role/'; }

    getAll() {
        return baseService.get(this.controllerName + 'getList');
    }

    getListHospitalAccessGroup() {
        return baseService.get(this.controllerName + 'SelectListHospitalAccessGroup');
    }

    getListHospitalAccessGroup_10_11() {
        return baseService.get(this.controllerName + 'SelectListHospitalAccessGroup_10_11');
    }

    getListCurrentPersonPermission() {
        return baseService.get(this.controllerName + 'GetListCurrentPersonPermission');
    }

    selectMemberAccessGroup(accessGroupId) {
        return baseService.get(this.controllerName + 'SelectMembersRole/' + accessGroupId);
    }

    selectPermissionAccessGroup(accessGroupId) {
        return baseService.get(this.controllerName + 'SelectPermissionOfRole/' + accessGroupId);
    }

    delete(itemId) {
        return baseService.get(this.controllerName + 'delete?id=' + itemId);
    }

    getDeleteUrl(itemId) {
        return this.controllerName + 'delete/' + itemId;
    }

    find(itemId) {
        return baseService.get(this.controllerName + 'find?id=' + itemId);
    }

    create(model) {
        return baseService.post(this.controllerName + 'create', model);
    }

    update(model) {
        return baseService.post(this.controllerName + 'update', model);
    }

    updateMembersRole(model) {
        return baseService.post(this.controllerName + 'UpdateMembersRole', model);
    }

    updatePermissionsRole(model) {
        return baseService.post(this.controllerName + 'UpdatePermissionsRole', model);
    }

}
export default new AccessGroupService();